const getPromos = content =>
  content.mainContent
    ? content.mainContent.filter(
        paragraph =>
          paragraph.entity && paragraph.entity.type === 'ParagraphPromo'
      )
    : undefined;

const getDataSubdirectory = (id, includeSeparator = true) => {
  const thousands = id >= 10_000 ? Math.floor(id / 10_000) * 10_000 : undefined;
  return includeSeparator ? `${thousands}/` : thousands;
};

module.exports = {
  getPromos,
  getDataSubdirectory
};
